function CircularProgressWithLabel(props) {
	const { value = 0, color = "#1976d2" } = props;
	const radius = 36;
	const circumference = 2 * Math.PI * radius;
	const offset = circumference - (value / 100) * circumference;

	return (
		<div className="relative inline-flex items-center justify-center" style={{ width: 80, height: 80 }}>
			<svg className="absolute" width={80} height={80} viewBox="0 0 80 80">
				<circle cx={40} cy={40} r={radius} fill="none" stroke="#e0e0e0" strokeWidth={4} />
				<circle
					cx={40}
					cy={40}
					r={radius}
					fill="none"
					stroke={color}
					strokeWidth={4}
					strokeLinecap="round"
					strokeDasharray={circumference}
					strokeDashoffset={offset}
					transform="rotate(-90 40 40)"
				/>
			</svg>
			<div className="flex flex-col items-center justify-center">
				<span className="text-lg text-gray-600">{`${value}%`}</span>
				<span className="text-[8px] text-gray-600">COMPLETED</span>
			</div>
		</div>
	);
}

export default CircularProgressWithLabel;
